export enum AvengersFeatureFlags {
    placeholder = ''
}
